export const noop = Symbol("nexus-noop");
export const event = Symbol("nexus-event");
